/* eslint-disable react-hooks/exhaustive-deps */
/****************************************************
Admin.tsx - Root component of the admin dashboard 
*****************************************************/
import React, { useState, useEffect, useMemo } from 'react';
import './Admin.scss';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChemicalDataUpload from './chemicalDataUpload/ChemicalDataUpload';
import ManageUser from './manageUser/ManageUser';
import UserNotAuthorised from './userNotAuthorised/UserNotAuthorised';
import Loader from "../../../common/Loader/Loader";
import Breadcrumb from '../../../common/Breadcrumb/Breadcrumb';
import { fetchAPI, METHODS } from "../../../../helper/functions/axios";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { adminUserRole } from "../../../../types/allTypes";
import { BASE_PAGE_PATHS } from "../../../../helper/constants";

const Admin = () => {
    const { API_PATHS, ADMIN_ROLES } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
    const [userRole, setUserRole] = useState<adminUserRole>(null);
    const navigate = useNavigate();
    //Role flags
    const isSuperAdmin = useMemo(() => {
        return userRole === ADMIN_ROLES.SUPERADMIN;
    }, [userRole]);
    const isAdminOrSuperAdmin = useMemo(() => {
        return ((userRole === ADMIN_ROLES.SUPERADMIN) || (userRole === ADMIN_ROLES.ADMIN));
    }, [userRole]);

    //get user roles
    useEffect(() => {
        fetchAPI(METHODS.POST, API_PATHS.GET_USER_ROLES)
            .then((response) => {
                const responseMessage = response?.data?.message || {};
                if (responseMessage?.isSuccess) {
                    //set user role
                    setUserRole(responseMessage?.result?.role || "");
                }
                else if(responseMessage?.result?.error === "InvalidToken"){
                    navigate(BASE_PAGE_PATHS.HOME);
                }
                else {
                    setUserRole("");               
                }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            }).catch((error) => {
                setUserRole("");
            });
    }, []);
    return (<> <Breadcrumb />
        {isAdminOrSuperAdmin ?
            <>
                <ChemicalDataUpload />
                {isSuperAdmin && <ManageUser />}
            </>
            :
            userRole == null ? <Loader /> : <UserNotAuthorised />}</>

    );
};

export default Admin;